import { api } from './client';
import type { ApiSuccess, PublicUser } from '@/types/api';

export const authApi = {
  /**
   * Guarda el idioma en la propia cuenta. Actua siempre sobre quien llama: el
   * servidor toma el usuario del token, nunca de la peticion.
   */
  async updatePreferences(input: { locale: 'es' | 'en' | 'de' }) {
    const res = await api.patch<ApiSuccess<{ user: PublicUser }>>(
      '/auth/me/preferences',
      input,
    );
    return res.data.data.user;
  },

  async login(email: string, password: string) {
    const res = await api.post<ApiSuccess<{ accessToken: string; user: PublicUser }>>(
      '/auth/login',
      { email, password },
    );
    return res.data.data;
  },

  async refresh() {
    const res = await api.post<ApiSuccess<{ accessToken: string; user: PublicUser }>>(
      '/auth/refresh',
      {},
    );
    return res.data.data;
  },

  async me() {
    const res = await api.get<ApiSuccess<{ user: PublicUser }>>('/auth/me');
    return res.data.data.user;
  },

  async logout() {
    await api.post('/auth/logout');
  },
};
